<dashboard-loader *ngIf="loadingModuleItemsConfig$ | async" [title]="'Loading available module items...'">
</dashboard-loader>
<div class="dashboard-module-item-list" *ngIf="moduleItemsConfigLoaded$ | async">
  <div class="dashboard-module-item-list__name">
    {{ selectedModule?.translations | dashboardTranslate: 'title':selectedLanguage?.code }}
  </div>
  <div
    class="dashboard-module-item-list__items"
    cdkDropListGroup
    fxLayout="row"
    fxLayoutAlign="space-between start"
    fxLayoutGap="20px"
  >
    <div fxFlex="100">
      <div fxFill>
        <p class="dashboard-module-item-list__items-info">
          {{ selectedModuleItems?.length + (selectedModuleItems?.length === 1 ? ' item' : ' items') | uppercase }}
        </p>
        <div fxLayout='row'
             fxFlex
             fxLayoutAlign='end center'
             fxLayoutGap='10px'>
          <button mat-raised-button
                  color='accent'
                  (click)="openModuleItemDialog(null, null)"
                  *ngIf='privilegeService.hasPrivilege(PRIVILEGE_SECTIONS.MODULES, PRIVILEGE_ACTIONS.ALL)'>
            {{ 'Add module item' | uppercase }}
          </button>
        </div>
      </div>
      <div
        cdkDropList
        id="selectedItemsList"
        [cdkDropListData]="selectedModuleItems"
        (cdkDropListDropped)="dropItem($event)"
        class="dashboard-module-item-list__items-list"
      >
        <div
          *ngIf="!selectedModuleItems?.length; else selectedList"
          class="dashboard-module-item-list__items-box--empty"
        >
          There are no {{ isScreening ? 'screening questions' : 'items' }} in this module. <br /><br />
          Please add an item by clicking the add module item button.
        </div>
        <form [formGroup]="calculatedVariableForm">
          <ng-template #selectedList>
            <div
              *ngFor="let item of selectedModuleItems; let i = index"
              cdkDrag
              cdkDragBoundary=".dashboard-module-item-list__items-list"
            >
              <div
                class="dashboard-module-item-list__items-box dashboard-module-item-list__items-box--selected"
                (click)="openModuleItemDialog(item, null, false)"
                fxLayout="row"
                fxLayoutAlign="space-between center"
              >
                <div fxLayout="row" fxLayoutGap="8px">
                  <mat-icon class="dashboard-module-item-list__items-box-icon--selected" color="primary">
                    {{ getIconBySubType(item?.subType) }}</mat-icon
                  >
                  <div fxLayout="row" fxLayoutGap="4px">
                    <p>{{ i + 1 }}.</p>
                    <div fxLayout="column" fxLayoutGap="4px">
                      <p
                        *ngIf="
                        item?.translations
                          | dashboardTranslate: 'question':selectedLanguage?.code
                          | dashboardStripHtml as question
                      "
                      >
                        {{
                        question?.length > questionLengthLimit
                          ? (question | slice: 0:questionLengthLimit) + '...'
                          : question
                        }}

                        <span class="identifier">(MI-{{ item.id}})</span>
                      </p>
                      <p class="dashboard-module-item-list__items-box-description">
                        {{ getSubTypeLabel(item) }}
                      </p>
                    </div>
                  </div>
                </div>
                <div formArrayName="calculatedVariables" fxLayout="row" fxLayoutGap="8px" style="align-items: center;">
                  <mat-form-field class="calculated-variable-input"
                                  *ngIf="item?.calculationName && calculatedVariables.controls[i]"
                                  [formGroup]="calculatedVariables.controls[i]">
                    <input type="text"
                           (focus)="onFocused()"
                           (focusout)="outFocused(i)"
                           matInput
                           formControlName="calculatedName"
                           placeholder="Name for numeric calculation" />
                    <mat-error *ngIf="calculatedVariables.controls[i].get('calculatedName').hasError('required')">
                      At least 1 character is needed.
                    </mat-error>
                    <mat-error *ngIf="calculatedVariables.controls[i].get('calculatedName').hasError('cannotContainSpace')">
                      Whitespace characters are not allowed.
                    </mat-error>
                    <mat-error *ngIf="calculatedVariables.controls[i].get('calculatedName').hasError('maxlength')">
                      <strong>At most {{ calculatedVariables.controls[i].get('calculatedName').errors?.maxlength.requiredLength }}</strong> characters allowed.
                    </mat-error>
                  </mat-form-field>
                  <mat-icon
                    *ngIf="
                    item?.routing &&
                    item?.routing?.routingGroups?.length &&
                    selectedModule?.randomization === RANDOMIZATION_VALUES.ROUTING
                  "
                    color="primary"
                    #tooltip="matTooltip"
                    matTooltip="This module has routing enabled"
                    matTooltipPosition="above"
                  >shuffle
                  </mat-icon>
                  <mat-icon
                    color="primary"
                    #tooltip="matTooltip"
                    matTooltip="Duplicate this item"
                    matTooltipPosition="above"
                    class="dashboard-module-item-list__items-box-action"
                    *ngIf="privilegeService.hasPrivilege(PRIVILEGE_SECTIONS.MODULES, PRIVILEGE_ACTIONS.ALL)"
                    (click)="$event.stopPropagation(); duplicateModuleItem(item)"
                  >content_copy
                  </mat-icon>
                  <mat-icon
                    color="primary"
                    #tooltip="matTooltip"
                    matTooltip="Remove this item"
                    matTooltipPosition="above"
                    class="dashboard-module-item-list__items-box-action"
                    *ngIf="privilegeService.hasPrivilege(PRIVILEGE_SECTIONS.MODULES, PRIVILEGE_ACTIONS.ALL)"
                    (click)="$event.stopPropagation(); deleteModuleItem(item)"
                  >delete
                  </mat-icon>
                </div>
              </div>
            </div>
          </ng-template>
        </form>
      </div>
    </div>
  </div>
</div>
